module.exports = __webpack_public_path__ + "static/media/unholy_curse.9637ce2e.png";